import React from 'react';
import styled from 'styled-components';
import AuthBackgroundLogo from '../../components/auth/AuthBackgroundLogo';
import AuthLogo from '../../components/auth/AuthLogo';
import PermissionRedirect from '../../components/PermissionRedirect';

const Container = styled.div`
  padding: 20px;
  font-family: 'Pretendard', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #fff;
  position: relative;
`;

const DescriptionBox = styled.div`
  width: 100%;
  max-width: 360px;
  padding: 40px 20px;
  border: 1px solid #ccc;
  text-align: center;
  margin-bottom: 20px;
`;

const Description = styled.p`
  font-size: 14px;
  color: #666;
  line-height: 1.5;
`;

const Button = styled.button`
  width: 100%;
  max-width: 360px;
  padding: 12px;
  border: none;
  font-size: 16px;
  color: white;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.subColor};

  &:hover {
    background-color: ${({ theme }) => theme.colors.subHoverColor};
  }
`;

const ResultPasswordPage = () => {
  return (
    <Container>
      <PermissionRedirect />
      <AuthLogo title="비밀번호 찾기" />
      <DescriptionBox>
        <Description>
          고객님이 가입하신 이메일 주소로
          <br />
          임시 비밀번호를 발급해 드렸습니다.
          <br />
          <br />
          고객님의 이메일을 확인해 주세요.
        </Description>
      </DescriptionBox>
      <Button>로그인하러 가기</Button>
      <AuthBackgroundLogo />
    </Container>
  );
};

export default ResultPasswordPage;
